import * as yup from "yup";

const today = new Date();
today.setHours(23, 59, 59, 999)

export const dependentCutoffDate = new Date(
  today.getFullYear() - 18,
  today.getMonth(),
  today.getDate()
);

export const mainRecipientCutoffDate = new Date(
    "1900-01-01T00:00:00"
);

const emailRegex =  new RegExp(`^([a-zA-Z0-9.!#$%&'*+/=?^_\`{|}~-]+(?:\\.[a-zA-Z0-9!#$%&'*+/=?^_\`{|}~-]+)*|"(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21\\x23-\\x5b\\x5d-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z
    0-9])?\\.)+[a-zA-Z]{2,}|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?=[-0-9a-zA-Z._]*\\])|(?:(?:[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)*)*)$`);

const containsAscending = (str) => {
  const strArr = str.split("");
  let ascendingFlag = false;
  for (let i = 0; i < str.length - 2; i++) {
    if (
      parseInt(strArr[i]) + 1 === parseInt(strArr[i + 1]) &&
      parseInt(strArr[i]) + 2 === parseInt(strArr[i + 2]) &&
      parseInt(strArr[i]) + 3 === parseInt(strArr[i + 3])
    ) {
      ascendingFlag = true;
    }
  }
  if (ascendingFlag) {
    return true;
  }
  return false;
};

export const schema = yup
  .object()
  .shape({
    firstName: yup
      .string()
      .trim()
      .matches(/^[a-zA-Z0-9\-.'",\s)(\*+]+$/, {
        message: "nameErrorMsg",
        excludeEmptyString: true,
      })
      .required("First name is required"),
    lastName: yup
      .string()
      .trim()
      .matches(/^[a-zA-Z0-9\-.'",\s)(\*+]+$/, {
        message: "nameErrorMsg",
        excludeEmptyString: true,
      })
      .required("Last name is required"),
    contactType: yup
      .string()
      .oneOf(["Phone", "Email"], "Select Phone or Email")
      .required("Please select a contact method"),

    contactPhone: yup.string().when("contactType", {
      is: "Phone",
      then: (s) => s
        .required("Please enter a valid phone number")
        .transform((number = "") => number.replace(/\D/g, ""))
        .matches(/^[0-9]{10}$/, "Please enter a valid phone number"),
      otherwise: (s) => s.notRequired(),
    }),

    contactEmail: yup.string().when("contactType", {
      is: "Email",
      then: (s) => s.required("emailErrorMsg")
      .matches(emailRegex, "emailErrorMsg"),
      otherwise: (s) => s.notRequired(),
    }),

    partitioned: yup
      .string()
      .required("")
      .matches(/^[0-9]{4}$/, "PIN must be exactly 4 digits")
      .test(
        "no-duplicates",
        "PIN cannot contain 4 duplicate numbers",
        (val) => !val || new Set(val).size > 1
      )
      .test(
        "no-ascending",
        "PIN cannot contain 4 consecutive numbers",
        (val) => !val || !containsAscending(val)
      ),
    requestType: yup
      .string()
      .oneOf(["DVR", "DCVR"], "Select a request type")
      .required("Please select an option"),
    
    dependents: yup
      .array()
      .when("requestType", {
        is: "DVR",
        then: (s) => s.of(yup.object().shape({
          FirstName: yup
            .string()
            .matches(/^[a-zA-Z0-9\-.'",\s)(\*+]+$/, {
              message: "nameErrorMsg",
              excludeEmptyString: true,
            })
            .trim()
            .required("First name is required"),
          LastName: yup
            .string()
            .matches(/^[a-zA-Z0-9\-.'",\s)(\*+]+$/, {
              message: "nameErrorMsg",
              excludeEmptyString: true,
            })
            .trim()
            .required("Last name is required"),
          DateOfBirth: yup
            .date()
            .typeError("Required Format: MM/DD/YYYY")
            .max(today, "dateOfBirthErrorMessage")
            .min(
              new Date(dependentCutoffDate.getTime() + 24 * 60 * 60 * 1000),
              "Please enter a valid date of birth for a minor (under 18 years old)"
            )
            .required("Date of birth is required"),
        })
      )
      .max(3, "Up to 3 dependents"),
        otherwise: (s) => s.notRequired(),
      }),
      
    dateOfBirth: yup
      .date()
      .when(["requestType", "dependents"], {
        is: (requestType, dependents) => requestType === "DVR" && dependents.length > 0,
        then: (s) => s.max(
              new Date(dependentCutoffDate.getTime() + 60 * 60 * 1000),
              "Please enter a valid date of birth for a Parent/Guardian (18 years old or older)"
            ),
      })
      .typeError("Required Format: MM/DD/YYYY")
      .max(today, "dateOfBirthErrorMessage")
      .min(
        mainRecipientCutoffDate,
        "Please enter a valid date of birth"
      )
      .required("Date of birth is required"),
      
    submitChecked: yup.boolean().oneOf([true], "You must agree to the policy"),
    submitChecked2: yup.boolean().oneOf([true], "You must agree to the policy"),
  })
  .required();
